import React from 'react'
import { PauseIcon, PlayIcon } from '@mote/assets/icons'
import type { AudioState } from './AudioState'
import type { CommonButtonProps } from './Common'
import { CommonButton } from './Common'

function getIconSize(size: CommonButtonProps['size']): string {
  switch (size) {
    case 'xs':
      return '24rpx'
    default:
      return '48rpx'
  }
}

export interface PlayPauseButtonProps {
  size?: CommonButtonProps['size']
  state: AudioState
  onPlay: () => void
  onPause: () => void
}

export function PlayPauseButton(props: PlayPauseButtonProps): JSX.Element {
  const [Icon, text, ariaLabel, id] =
    props.state === 'playing'
      ? ([PauseIcon, 'Pause (k)', 'pause', 'mote-player-pause-button'] as const)
      : ([PlayIcon, 'Play (k)', 'play', 'mote-player-play-button'] as const)

  return (
    <CommonButton
      variant={'primary'}
      size={props.size || 'm'}
      id={id}
      ariaLabel={ariaLabel}
      text={text}
      onClick={props.state === 'playing' ? props.onPause : props.onPlay}
    >
      <Icon width={getIconSize(props.size)} height={getIconSize(props.size)} />
    </CommonButton>
  )
}
